import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {EntityInfoComponent} from './entity-info.component';
import {FuseSharedModule} from '../../../@fuse/shared.module';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {EstimationListModule} from '../estimation-list/estimation-list.module';



@NgModule({
    declarations: [EntityInfoComponent],
    exports: [
        EntityInfoComponent
    ],
    imports: [
        CommonModule,
        FuseSharedModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatButtonModule,
        MatCheckboxModule,
        MatToolbarModule,
        MatIconModule,
        EstimationListModule
    ]
})
export class EntityInfoModule { }
